import React, { ReactNode } from 'react';
import styles from './LayoutMobileBackHeader.module.scss';
import BackHeader from '../../BackHeader/BackHeader';
import LayoutMobile, { LayoutMobileProps } from '../LayoutMobile';

export interface LayoutMobileBackProps {
  backAction?: () => void,
  backHidden?: boolean
}

interface LayoutMobileBackHeaderProps extends JSX.ElementChildrenAttribute, LayoutMobileProps, LayoutMobileBackProps  {
  header?: ReactNode,
}

function LayoutMobileBackHeader(props: LayoutMobileBackHeaderProps) {
  const { children, header, backAction, backHidden, className } = props;
  return (
    <LayoutMobile className={className}>
      <BackHeader backHidden={backHidden} action={backAction}>{header}</BackHeader>
      <div className={styles.body}>
        { children }
      </div>
    </LayoutMobile>
  )
}

export default LayoutMobileBackHeader;
